
import error404 from '~/components/error/404'
import error500 from '~/components/error/500'
export default {
  name: 'NuxtError',
  layout: 'default', // optional
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    errorPage() {
      if (this.error.statusCode === 500) {
        return error500
      }
      // catch everything else
      return error404
    },
  },
}
